import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { tr } from '@util/tr';

@Injectable({
  providedIn: 'root', // Makes the service available globally
})
export class WsPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = tr('Items per page') + ":";
  nextPageLabel = '';
  previousPageLabel = '';
  firstPageLabel = '';
  lastPageLabel = '';

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return tr('Results') + ": 0 " + tr("of") + ` ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return tr('Results') + `: ${startIndex + 1} - ${endIndex} ${tr("of")} ${length}`;
  };
}